import { render, staticRenderFns } from "./invoice-credit.vue?vue&type=template&id=45f8b826"
import script from "./invoice-credit.vue?vue&type=script&lang=js"
export * from "./invoice-credit.vue?vue&type=script&lang=js"
import style0 from "./invoice-credit.vue?vue&type=style&index=0&id=45f8b826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports